import React, { Component } from 'react';
import { List } from 'immutable';
import Policies from './Policies';
import ChannelStyles from './ChannelStyles';
import css from './channel.css';

import MdCheck from 'react-icons/lib/md/check';
import MdModeEdit from 'react-icons/lib/md/mode-edit';

import { grey800 } from 'material-ui/styles/colors';
import TextField from 'material-ui/TextField';
import FlatButton from 'material-ui/FlatButton';

class Channel extends Component {

  constructor(props) {
    super(props);
    this.formAttributes = {
      name: '',
      url: '',
      channelPoliciesAttributes: List(),
      channelChannelStylesAttributes: List(),
    };
    this.state = {
      channelName: '',
      open: true,
    };
  }

  componentWillUnmount() {
    this.formAttributes = null;
  }

  handleFormUpdate = (property, value) => {
    this.formAttributes[property] = value;

    // Update parent form attributes
    this.props.updateForm(this.formAttributes);
  };

  handleInputChange = (property, e) => {
    this.handleFormUpdate(property, e.target.value);
  };

  handleUpdateChannelStyles = (ids) => {
    this.formAttributes.channelChannelStylesAttributes = ids;
  };

  handleToggleForm = () => {
    if (this.props.hidden) {
      // Open
      this.setState({
        channelName: '',
      });
    } else {
      // Close
      this.setState({
        channelName: this.formAttributes.name,
      });
    }

    this.props.toggleChannel(this.props.id);
  };

  render() {
    return (
      <div className={css.root}>
        <h4 className={css.title}>
          {this.state.channelName || 'Editing Channel'}
          <FlatButton
            primary={true}
            onTouchTap={this.handleToggleForm}
          >
            {this.props.hidden ? 'Edit' : 'Done'}
          </FlatButton>
        </h4>
        <div className={css.formFields} style={this.props.hidden ? { display: 'none' } : {}}>
          <TextField
            floatingLabelText="Name"
            onChange={this.handleInputChange.bind(this, 'name')}
            fullWidth={true}
          />
          <TextField
            floatingLabelText="URL"
            onChange={this.handleInputChange.bind(this, 'url')}
            fullWidth={true}
          />
          <h4 className={css.title}>Channel Styles</h4>
          <ChannelStyles
            channelStyles={this.props.channelStyles}
            updateChannelStyles={this.handleUpdateChannelStyles}
          />
          <h4 className={css.title}>Policies</h4>
          <Policies updateForm={this.handleFormUpdate.bind(this, 'channelPoliciesAttributes')} />
        </div>
      </div>
    );
  }
};

export default Channel;



/** WEBPACK FOOTER **
 ** ./components/forms/Channel.js
 **/